// A new student's proof of a verified .edu address, kept for the tab session so a refresh in the middle
// of checkout doesn't lose it. The server issues it for 30 minutes; this drops it a minute early.
const KEY = 'studentDiscountProof';
const LIFETIME_MS = 29 * 60 * 1000;

const read = () => {
  try {
    const saved = JSON.parse(sessionStorage.getItem(KEY) || 'null');
    if (saved && saved.token && saved.expiresAt > Date.now()) return saved;
    sessionStorage.removeItem(KEY);
  } catch { /* storage unavailable or unreadable */ }
  return null;
};

export const saveStudentProof = (token, eduEmail) => {
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ token, eduEmail, expiresAt: Date.now() + LIFETIME_MS }));
  } catch { /* the discount just won't survive a refresh */ }
};

export const getStudentToken = () => read()?.token || null;
// When the saved proof stops being good (ms since epoch), so the page can stop offering the discount then.
export const getStudentProofExpiry = () => read()?.expiresAt || null;
export const getStudentEduEmail = () => read()?.eduEmail || null;

export const clearStudentProof = () => {
  try { sessionStorage.removeItem(KEY); } catch { /* nothing saved */ }
};

// The student removed the discount, on the catalog or the payment page (to use the bundle offer or a promo
// code instead). Every price request and payment says so, so what is charged is what the page shows. Kept for
// the tab session so a refresh doesn't undo the choice.
const REMOVED_KEY = 'studentDiscountRemoved';

export const markStudentDiscountRemoved = () => {
  try { sessionStorage.setItem(REMOVED_KEY, '1'); } catch { /* the server still applies it */ }
};

export const studentDiscountWasRemoved = () => {
  try { return sessionStorage.getItem(REMOVED_KEY) === '1'; } catch { return false; }
};

export const clearStudentDiscountRemoved = () => {
  try { sessionStorage.removeItem(REMOVED_KEY); } catch { /* nothing saved */ }
};

// The proof to send with a price request or a payment: none once the student removed the discount, so the
// bundle offer (or a promo code) is priced and charged instead.
export const getUsableStudentToken = () => (studentDiscountWasRemoved() ? null : getStudentToken());
